import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";

interface ImportInput {
    files: Array<{ fileId: string; mimeType?: string; name?: string }>;
}

interface ImportedFile {
    fileId: string;
    name: string | null;
    mimeType: string | null;
    content: string;
    error: string | null;
}

export function useImportGoogleDriveFilesMutation() {
    return useMutation({
        mutationFn: async (input: ImportInput): Promise<ImportedFile[]> => {
            const res = await apiClient.importGoogleDriveFiles({
                body: { files: input.files },
            });

            if (res.status !== 200) {
                throw new Error("Failed to fetch Google Drive file contents");
            }

            return res.body.files;
        },
    });
}
